export const fakeLineUpDemo = {
  "homeLineups": {
    teamId: 'a229b14b-cdbe-47f1-abb4-b77e01bcc4ad',
    seasonId: '5eada734-c79b-4275-9c0a-16d383f77463',
    players: [
      {
        "id": "263e0da0-3cf6-4636-a898-dc4112a515c0",
        "fullName": "Pintade 0",
        "jerseyNumber": 0,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 0
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      // QB
      {
        "id": "263e0da0-3cf6-4636-a898-dc4112a515c0",
        "fullName": "Pintade 1",
        "jerseyNumber": 1,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 1
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      {
        "id": "cac77082-1fe8-49fc-a1ff-c38e0a7df0dd",
        "fullName": "Pintade 2",
        "jerseyNumber": 2,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 2
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      // RB
      {
        "id": "aee6bf1d-4f63-4f22-919f-1fc636ee3ac5",
        "fullName": "Pintade 3",
        "jerseyNumber": 3,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 3
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "RB"
          }
        ]
      },
      // WR
      {
        "id": "59727387-afaf-4683-81b9-b16dfdec5e38",
        "fullName": "Pintade 4",
        "jerseyNumber": 4,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 4
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "WR"
          }
        ]
      },
      {
        "id": "8a34dc6a-57e6-4ab8-925b-6b8001408912",
        "fullName": "Pintade 5",
        "jerseyNumber": 5,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 5
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "WR"
          }
        ]
      },
      // OL
      {
        "id": "bf73f355-a4d1-401f-bbb1-e904cca04f43",
        "fullName": "Pintade 6",
        "jerseyNumber": 6,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 6
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "OL"
          }
        ]
      },
      // DL
      {
        "id": "71df45e0-9b62-41d5-ade8-53b53a1cb04b",
        "fullName": "Pintade 7",
        "jerseyNumber": 7,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 7
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DL"
          }
        ]
      },
      // LB
      {
        "id": "d753e5d8-9ed9-4fbb-b256-9f889f2ff728",
        "fullName": "Pintade 8",
        "jerseyNumber": 8,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 8
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "LB"
          }
        ]
      },
      {
        "id": "04cea6af-2307-4d62-a104-ed5e27b5032d",
        "fullName": "Pintade 9",
        "jerseyNumber": 9,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 9
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "LB"
          }
        ]
      },
      // DB
      {
        "id": "1ff26c25-fa22-424c-ab37-172a1e101c08",
        "fullName": "Pintade 10",
        "jerseyNumber": 10,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 10
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DB"
          }
        ]
      },
      {
        "id": "Pintade 11",
        "fullName": "Pintade 11",
        "jerseyNumber": 11,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 11
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DB"
          }
        ]
      },
      // K
      {
        "id": "Pintade 12",
        "fullName": "Pintade 12",
        "jerseyNumber": 12,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 12
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "K"
          }
        ]
      },
      {
        "id": "Pintade 13",
        "fullName": "Pintade 13",
        "jerseyNumber": 13,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 13
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "K"
          }
        ]
      },
    ]
  },

  "awayLineups": {
    teamId: "ddf2ece8-64c7-4efd-8121-090b44748ac5",
    seasonId: "5eada734-c79b-4275-9c0a-16d383f77463",
    players: [
      {
        "id": "263e0da0-3cf6-4636-a898-dc4112a515c0",
        "fullName": "Escargo 0",
        "jerseyNumber": 0,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 0
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      // QB
      {
        "id": "263e0da0-3cf6-4636-a898-dc4112a515c0",
        "fullName": "Escargo 51",
        "jerseyNumber": 51,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 51
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      {
        "id": "cac77082-1fe8-49fc-a1ff-c38e0a7df0dd",
        "fullName": "Escargo 52",
        "jerseyNumber": 52,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 52
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "QB"
          }
        ]
      },
      // RB
      {
        "id": "aee6bf1d-4f63-4f22-919f-1fc636ee3ac5",
        "fullName": "Escargo 53",
        "jerseyNumber": 53,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 53
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "RB"
          }
        ]
      },
      // WR
      {
        "id": "59727387-afaf-4683-81b9-b16dfdec5e38",
        "fullName": "Escargo 54",
        "jerseyNumber": 54,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 54
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "WR"
          }
        ]
      },
      {
        "id": "8a34dc6a-57e6-4ab8-925b-6b8001408912",
        "fullName": "Escargo 55",
        "jerseyNumber": 55,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 55
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "WR"
          }
        ]
      },
      // OL
      {
        "id": "bf73f355-a4d1-401f-bbb1-e904cca04f43",
        "fullName": "Escargo 56",
        "jerseyNumber": 56,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 56
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "OL"
          }
        ]
      },
      // DL
      {
        "id": "71df45e0-9b62-41d5-ade8-53b53a1cb04b",
        "fullName": "Escargo 57",
        "jerseyNumber": 57,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 57
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DL"
          }
        ]
      },
      // LB
      {
        "id": "d753e5d8-9ed9-4fbb-b256-9f889f2ff728",
        "fullName": "Escargo 58",
        "jerseyNumber": 58,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 58
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "LB"
          }
        ]
      },
      {
        "id": "04cea6af-2307-4d62-a104-ed5e27b5032d",
        "fullName": "Escargo 59",
        "jerseyNumber": 59,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 59
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "LB"
          }
        ]
      },
      // DB
      {
        "id": "1ff26c25-fa22-424c-ab37-172a1e101c08",
        "fullName": "Escargo 60",
        "jerseyNumber": 60,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 60
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DB"
          }
        ]
      },
      {
        "id": "31de79db-ee90-4d14-82e2-678250e89762",
        "fullName": "Escargo 61",
        "jerseyNumber": 61,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 61
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "DB"
          }
        ]
      },
      // K
      {
        "id": "464d0c54-33ed-488c-a988-5c7dd9c7df09",
        "fullName": "Escargo 62",
        "jerseyNumber": 62,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 62
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "K"
          }
        ]
      },
      {
        "id": "b256839a-8c2a-45e0-acaa-164a37760c33",
        "fullName": "Escargo 63",
        "jerseyNumber": 63,
        "gamesPlayed": [
          {
            "gameJerseyNumber": 63
          }
        ],
        "teamId": "team-1",
        "playerPositions": [
          {
            "position": "K"
          }
        ]
      },
    ]
  }
}
